import {
	Button,
	FilterCheckbox,
	Flex,
	INNER_MAX_WIDTH,
} from "@capioweb/ui-components/src"
import React from "react"
import AnimateHeight from "react-animate-height"
import { PaginationContext } from "../../../components/PaginationBlock/context/PaginationContext"
import { LocalesContext } from "../../../context"
import { sendOpenFilterDataLayerPush } from "../../../utils"
import { SearchFilterValue } from "../@types/SearchFilterValue"
import { SiteSearchFilterContext } from "../context"

interface SiteSearchSectionProps {
	filterValues: SearchFilterValue[]
}

const FilterSection: React.FC<SiteSearchSectionProps> = ({ filterValues }) => {
	const { activeFilterIds, updateActiveFilterIds } = React.useContext(
		SiteSearchFilterContext
	)
	const { setActivePage } = React.useContext(PaginationContext)
	return (
		<Flex w={1} flexDirection="column" pb={1.5} mb={{ _: 0, l: 2 }}>
			{filterValues?.length > 0 && (
				<Flex w={1} flexWrap="wrap">
					{filterValues.map((filter, i) => {
						return (
							<Flex pb={1.5} pr={1.5} key={`${filter.id} ` + i}>
								<FilterCheckbox
									checked={activeFilterIds.includes(filter.id)}
									label={filter.name}
									value={filter.id.toString()}
									onChange={() => {
										setActivePage("1")
										updateActiveFilterIds(filter.id)
									}}
									withoutBorder={true}
									hits={filter.hits}
								/>
							</Flex>
						)
					})}
				</Flex>
			)}
		</Flex>
	)
}

interface SiteSearchFilterProps {
	pageFilterValues: SearchFilterValue[]
}

const SiteSearchFilter: React.FC<SiteSearchFilterProps> = ({
	pageFilterValues,
}) => {
	const { translate, translationKeys } = React.useContext(LocalesContext)
	const { activeFilterIds } = React.useContext(SiteSearchFilterContext)
	const [filterOpen, setFilterOpen] = React.useState(activeFilterIds.length > 0)
	return (
		<>
			<Flex w={1} py={3} justifyContent="center" backgroundColor="blue11">
				<Button
					variant="ghost-navy"
					icon="filter"
					textColor="navy"
					onClick={() => {
						setFilterOpen(!filterOpen)
						sendOpenFilterDataLayerPush(filterOpen ? "close" : "open")
					}}
				>
					{`${
						filterOpen
							? translate(translationKeys.close)
							: translate(translationKeys.open)
					} ${translate(translationKeys.filter)}`}
				</Button>
			</Flex>
			<AnimateHeight height={filterOpen ? "auto" : 0}>
				<Flex w={1} px={3} backgroundColor="blue11">
					<Flex w={1} flexDirection="column" maxw={INNER_MAX_WIDTH} m="0 auto">
						{/* Filter layout for screens >= l */}
						<Flex w={1} display={{ _: "none", l: "block" }}>
							{pageFilterValues?.length > 0 && (
								<FilterSection filterValues={pageFilterValues} />
							)}
						</Flex>

						{/* Filter layout for screens < l */}
						<Flex
							w={1}
							display={{ _: "flex", l: "none" }}
							flexDirection="column"
							pb={4.5}
						>
							<FilterSection filterValues={pageFilterValues} />
						</Flex>
					</Flex>
				</Flex>
			</AnimateHeight>
		</>
	)
}
export { SiteSearchFilter }
